<div id="{{ id }}" class="carousel slide" data-interval="false">
  <div class="carousel-inner">
    <div class="carousel-item" [ngClass]="{ 'active': i == 0 }" *ngFor="let component of components; let i = index;" >
      <ng-template appTabContentHost></ng-template>
    </div>
  </div>
</div>
